import { useCallback, useRef } from 'react';

import { useIsomorphicLayoutEffect } from 'utils/hooks/useIsomorphicLayoutEffect';

import { WindowScroll, getWindowScroll } from './getWindowScroll';

export function useScrollEffect(
  fn: (position: WindowScroll) => void,
  options: { skipBootTrigger?: boolean } = {}
) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  const handleScroll = useCallback(() => {
    fnRef.current(getWindowScroll());
  }, []);

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);
    if (!options.skipBootTrigger) handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
}
